<ng-container *ngIf="!history">
	Loading history...
</ng-container>
<ng-container *ngIf="history">
	<h3>Movements</h3>
	<nz-table [nzBordered]="true" [nzFrontPagination]="false" [nzData]="history.movements">
		<thead>
			<tr>
				<th>When</th>
				<th>Agent</th>
				<th>To Step</th>
				<th>To State</th>
				<th>Button Clicked</th>
				<th>Assigned To</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let movement of history.movements">
				<td>{{movement.createdAt|date:'yyyy/MM/dd HH:mm:ss'}}</td>
				<td>{{movement.triggeredByAgent.firstName}} {{movement.triggeredByAgent.lastName}}</td>
				<td>{{movement.workflowStep.label}}</td>
				<td>{{movement.workflowStepStatus.label}}</td>
				<td>{{movement.workflowStepButton?.label??'-'}}</td>
				<td *ngIf="movement.assignedToAgent">{{movement.assignedToAgent.firstName}} {{movement.assignedToAgent.lastName}}</td>
				<td *ngIf="!movement.assignedToAgent">-</td>
			</tr>
		</tbody>
	</nz-table>

	<h3 class="mt-3">Additional Comments</h3>
	<nz-table [nzBordered]="true" [nzFrontPagination]="false" [nzData]="history.additionalComments">
		<thead>
			<tr>
				<th>When</th>
				<th>Agent</th>
				<th>Step</th>
				<th>State</th>
				<th>Comment</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let comment of history.additionalComments">
				<td>{{comment.createdAt|date:'yyyy/MM/dd HH:mm:ss'}}</td>
				<td>{{comment.agent.firstName}} {{comment.agent.lastName}}</td>
				<td>{{comment.workflowStep.label}}</td>
				<td>{{comment.workflowStepStatus.label}}</td>
				<td><p>{{comment.comment}}</p></td>
			</tr>
		</tbody>
	</nz-table>


	<h3 class="mt-3">Communications</h3>
	<nz-table [nzBordered]="true" [nzFrontPagination]="false" [nzData]="history.communications">
		<thead>
			<tr>
				<th>When</th>
				<th>Agent</th>
				<th>Channel</th>
				<th>Name</th>
				<th>Recipient</th>
				<th>Type</th>
				<th>Subject</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let communication of history.communications">
				<td>{{communication.createdAt|date:'yyyy/MM/dd HH:mm:ss'}}</td>
				<td *ngIf="communication.triggeredByAgent">{{communication.triggeredByAgent.firstName}} {{communication.triggeredByAgent.lastName}}</td>
				<td *ngIf="!communication.triggeredByAgent">-</td>
				<td>{{communication.type}}</td>
				<td>{{communication.name??'-'}}</td>
				<td *ngIf="communication.type == 'Email'">
					<span *ngIf="communication.emailTo">{{communication.emailTo}}</span>
					<span *ngIf="!communication.emailTo && communication.emailCc">{{communication.emailCc}}</span>
					<span *ngIf="!communication.emailTo && !communication.emailCc && communication.emailBcc">{{communication.emailBcc}}</span>
				</td>
				<td *ngIf="communication.type == 'Sms'">{{communication.smsMsisdn}}</td>
				<td>{{communication.type}}</td>
				<td *ngIf="communication.type == 'Email'">{{communication.emailSubject}}</td>
				<td *ngIf="communication.type == 'Sms'">-</td>
			</tr>
		</tbody>
	</nz-table>

	<h3 class="mt-3">Captured Fields</h3>
	<nz-table [nzBordered]="true" [nzFrontPagination]="false" [nzData]="history.fields">
		<thead>
			<tr>
				<th>When</th>
				<th>Agent</th>
				<th>Step</th>
				<th>Section</th>
				<th>Field</th>
				<th>Value</th>
			</tr>
		</thead>
		<tbody>
			<ng-container *ngFor="let field of history.fields; let i=index">
				<tr *ngIf="field.inputValue != null">
					<td>{{field.createdAt|date:'yyyy/MM/dd HH:mm:ss'}}</td>
					<td>{{field.agentFullName}}</td>
					<td>{{field.workflowStepLabel}}</td>
					<td>{{field.workflowSectionLabel}}</td>
					<td>{{field.inputLabel}}</td>
					<td [ngSwitch]="field.dataType">
						<ng-container *ngSwitchCase="'Text'">{{field.inputValue}}</ng-container>
						<ng-container *ngSwitchCase="'TextArea'">{{field.inputValue}}</ng-container>
						<ng-container *ngSwitchCase="'Boolean'">{{field.inputValue}}</ng-container>
						<ng-container *ngSwitchCase="'DropDownSingle'">{{field.inputValue}}</ng-container>
						<ng-container *ngSwitchCase="'Number'">{{field.inputValue}}</ng-container>
						<ng-container *ngSwitchCase="'PastDate'">{{field.inputValue}}</ng-container>
						<ng-container *ngSwitchCase="'FutureDate'">{{field.inputValue}}</ng-container>
						<ng-container *ngSwitchCase="'Date'">{{field.inputValue}}</ng-container>
						<ng-container *ngSwitchCase="'Time'">{{field.inputValue}}</ng-container>
						<ng-container *ngSwitchCase="'PastDateTime'">{{field.inputValue}}</ng-container>
						<ng-container *ngSwitchCase="'FutureDateTime'">{{field.inputValue}}</ng-container>
						<ng-container *ngSwitchCase="'File'">
							<button *ngIf="field.inputValue" nz-button [nzType]="'dashed'" (click)="doDownload(field)">Download</button>
							<span *ngIf="!field.inputValue">&nbsp;</span>
						</ng-container>
						<ng-container *ngSwitchCase="'Password'">
							<span *ngIf="field.inputValue">************</span>
							<span *ngIf="!field.inputValue">&nbsp;</span>
						</ng-container>
						<ng-container *ngSwitchCase="'Email'">{{field.inputValue}}</ng-container>
						<ng-container *ngSwitchCase="'Msisdn'">{{field.inputValue}}</ng-container>
						<ng-container *ngSwitchCase="'SetOfRecords'">
							<span *ngIf="field.inputValue">LIST</span>
							<span *ngIf="!field.inputValue">&nbsp;</span>
						</ng-container>
						<ng-container *ngSwitchCase="'SelectFromRecords'">{{field.inputValue}}</ng-container>
						<ng-container *ngSwitchCase="'RequiredCheckbox'">{{field.inputValue}}</ng-container>
						<ng-container *ngSwitchDefault>{{field.inputValue}}</ng-container>
					</td>
				</tr>
			</ng-container>
		</tbody>
	</nz-table>
</ng-container>


















'
